
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-slate-900/90 text-white">
      <div className="container mx-auto px-6 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo y Empresa */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <img 
                alt="INDEFINHUM Logo" 
                className="h-10 w-auto object-contain" 
                src="https://static.readdy.ai/image/c9dd91c630c89e34554970cc86118743/c21e21ece24cfd7a637296305c96022e.jfif"
              />
              <div className="flex items-center space-x-2">
                <div className="text-lg font-bold bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500 bg-clip-text text-transparent">
                  INDEFINHUM
                </div>
              </div>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed mb-4">
              LA SABIDURÍA VENCERÁ TUS LIMITACIONES
            </p>
            <p className="text-gray-300 text-sm leading-relaxed">
              Expertos en transformación financiera personal, emprendimientos, PyMEs y consultoría empresarial con metodologías probadas.
            </p>
          </div>

          {/* Navegación */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-yellow-400">Navegación</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/presentacion" className="text-gray-300 hover:text-yellow-400 transition-colors cursor-pointer">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/modulos" className="text-gray-300 hover:text-yellow-400 transition-colors cursor-pointer">
                  Módulos del Curso
                </Link>
              </li>
              <li>
                <Link to="/precios" className="text-gray-300 hover:text-yellow-400 transition-colors cursor-pointer">
                  Planes y Precios
                </Link>
              </li>
              <li>
                <Link to="/pago" className="text-gray-300 hover:text-yellow-400 transition-colors cursor-pointer">
                  Proceso de Pago
                </Link>
              </li>
            </ul>
          </div>

          {/* Servicios */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-yellow-400">Servicios</h4>
            <ul className="space-y-3">
              <li>
                <span className="text-gray-300">Conferencias</span>
              </li>
              <li>
                <span className="text-gray-300">Cursos Intensivos</span>
              </li>
              <li>
                <span className="text-gray-300">Talleres Prácticos</span>
              </li>
              <li>
                <span className="text-gray-300">Entrenamientos</span>
              </li>
              <li>
                <span className="text-gray-300">Test Financiero Gratuito</span>
              </li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-yellow-400">Contacto</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center">
                <i className="ri-mail-line mr-3 text-yellow-400"></i>
                <span className="text-gray-300">indefinhum@gmail.com</span>
              </li>
              <li className="flex items-center">
                <i className="ri-phone-line mr-3 text-yellow-400"></i>
                <span className="text-gray-300">+52 55 2369 8187</span>
              </li>
              <li className="flex items-center">
                <i className="ri-user-line mr-3 text-yellow-400"></i>
                <span className="text-gray-300">Israel Bertotti Santillán</span>
              </li>
              <li className="flex items-center">
                <i className="ri-briefcase-line mr-3 text-yellow-400"></i>
                <span className="text-gray-300">Coach Financiero EC0249</span>
              </li>
            </ul>
            
            <div className="mt-6">
              <h5 className="font-semibold mb-2 text-yellow-400">Especialidades</h5>
              <div className="flex flex-wrap gap-2">
                <span className="bg-slate-800 text-yellow-400 px-2 py-1 rounded text-xs">Finanzas</span>
                <span className="bg-slate-800 text-yellow-400 px-2 py-1 rounded text-xs">IA</span>
                <span className="bg-slate-800 text-yellow-400 px-2 py-1 rounded text-xs">PyMEs</span>
                <span className="bg-slate-800 text-yellow-400 px-2 py-1 rounded text-xs">Networking</span>
              </div>
            </div>
          </div>
        </div>

        {/* Línea divisoria */}
        <div className="border-t border-slate-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 INDEFINHUM. Todos los derechos reservados.
            </p>
            <div className="flex items-center space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-gray-400 hover:text-yellow-400 text-sm cursor-pointer">
                Servicios
              </a>
              <a href="#" className="text-gray-400 hover:text-yellow-400 text-sm cursor-pointer">
                Test Financiero
              </a>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-white text-sm cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
